/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 * CampaignInfo component styles
 *
 * @author Yakov Gushchin
 * @version 1.15.0
 * @since 1.12.0
 */

import styled from 'styled-components';

import { fonts } from '../../../../theme';

export const CampaignInfoStyled = styled.div.attrs({
    className: 'campaign-info',
})<{ isTableVisible: boolean }>`

    .campaign-info__content {
        display: grid;
        grid-template-columns: ${props => props.isTableVisible ? '1fr 2fr' : '100%'};
        grid-column-gap: 20px;
    }

    .error-page {
        padding-bottom: 32px;
    }
`;

export const CampaignInfoCardStyled = styled.div.attrs({
    className: 'campaign-info__card',
})`

    .card__details,
    .card__description,
    .card__image-container {
        margin-bottom: 16px;
    }

    .card__title {
        ${fonts.textHeader3};
        margin-bottom: 16px;
    }

    .card__image-container {
        text-align: center;
    }

    .card__image {
        max-width: 100%;
    }

    .card__description {
        max-height: 150px;
        overflow: auto;
    }

    .card__details {
        display: block;
    }

    .card__participant-chosen {
        ${fonts.textSmall};
        margin-bottom: 12px;
    }

    .card__btn-container {
        & > *:not(:last-child) {
            margin-right: 24px;
        }
    }
`;
